import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { updateProfile } from '../utils/api';
import toast from 'react-hot-toast';

export default function ProfilePage() {
  const { user, login } = useAuth();
  const [form, setForm] = useState({ name: user?.name || '', phone: user?.phone || '', password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState('profile');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password && form.password !== form.confirm) { toast.error('Passwords do not match'); return; }
    setLoading(true);
    try {
      const payload = { name: form.name, phone: form.phone };
      if (form.password) payload.password = form.password;
      const { data } = await updateProfile(payload);
      login(data);
      toast.success('Profile updated!');
      setForm(f => ({ ...f, password: '', confirm: '' }));
    } catch (err) {
      toast.error(err.response?.data?.message || 'Update failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="container" style={{ padding:'1.5rem 1rem', maxWidth:640 }}>
      <h1 style={{ fontSize:'1.5rem', fontWeight:700, marginBottom:'1.5rem' }}>👤 My Profile</h1>
      <div className="card" style={{ overflow:'hidden' }}>
        {/* Tabs */}
        <div style={{ display:'flex', borderBottom:'1px solid var(--border)' }}>
          {['profile','security'].map(t => (
            <button key={t} onClick={() => setTab(t)} style={{ flex:1, padding:'0.875rem', border:'none', background:tab===t?'var(--primary-light)':'#fff', color:tab===t?'var(--primary)':'var(--text-secondary)', fontWeight:tab===t?700:500, borderBottom:tab===t?'2px solid var(--primary)':'2px solid transparent', textTransform:'capitalize' }}>
              {t === 'profile' ? '👤 Profile Info' : '🔒 Change Password'}
            </button>
          ))}
        </div>
        <div style={{ padding:'1.5rem' }}>
          {/* User meta */}
          <div style={{ display:'flex', alignItems:'center', gap:'1rem', marginBottom:'1.5rem', padding:'1rem', background:'var(--primary-light)', borderRadius:'var(--radius-sm)' }}>
            <div style={{ width:56, height:56, borderRadius:'50%', background:'var(--primary)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.4rem', fontWeight:800 }}>
              {user?.name?.[0]}
            </div>
            <div>
              <p style={{ fontWeight:700 }}>{user?.name}</p>
              <p style={{ fontSize:'0.875rem', color:'var(--text-secondary)' }}>{user?.email}</p>
              <p style={{ fontSize:'0.75rem', color:'var(--primary)', fontWeight:600, textTransform:'uppercase', marginTop:2 }}>{user?.role}</p>
            </div>
          </div>
          <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:'0.875rem' }}>
            {tab === 'profile' && (
              <>
                <div className="form-group">
                  <label className="form-label">Full Name</label>
                  <input className="form-input" value={form.name} onChange={e => setForm(f=>({...f,name:e.target.value}))} required />
                </div>
                <div className="form-group">
                  <label className="form-label">Email (read-only)</label>
                  <input className="form-input" value={user?.email} readOnly style={{ background:'var(--bg)', cursor:'default' }} />
                </div>
                <div className="form-group">
                  <label className="form-label">Phone Number</label>
                  <input className="form-input" value={form.phone} onChange={e => setForm(f=>({...f,phone:e.target.value}))} placeholder="01XXXXXXXXX" />
                </div>
              </>
            )}
            {tab === 'security' && (
              <>
                <div className="form-group">
                  <label className="form-label">New Password</label>
                  <input type="password" className="form-input" value={form.password} onChange={e => setForm(f=>({...f,password:e.target.value}))} placeholder="Min 6 characters" minLength={6} />
                </div>
                <div className="form-group">
                  <label className="form-label">Confirm New Password</label>
                  <input type="password" className="form-input" value={form.confirm} onChange={e => setForm(f=>({...f,confirm:e.target.value}))} placeholder="Repeat password" />
                </div>
              </>
            )}
            <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
              {loading ? 'Saving…' : 'Save Changes'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
